import config from '../config';

/**
 * Default page size for "Get All" API calls
 * Can be overridden by setting REACT_APP_DEFAULT_PAGE_SIZE environment variable
 * Default value: 200
 * Maximum allowed: 200
 */
export const DEFAULT_PAGE_SIZE = config.pagination.DEFAULT_PAGE_SIZE;

/**
 * Maximum allowed page size for API calls
 * Prevents server errors from requesting too many records at once
 */
export const MAX_PAGE_SIZE = 200;

/**
 * Get page size ensuring it doesn't exceed maximum
 * @param pageSize - Requested page size
 * @returns Page size capped at MAX_PAGE_SIZE
 */
export const getPageSize = (pageSize?: number): number => {
  if (!pageSize) {
    return DEFAULT_PAGE_SIZE;
  }
  return Math.min(pageSize, MAX_PAGE_SIZE);
};


